import React from 'react';

interface PoweredByFooterProps {
  className?: string;
}

const PoweredByFooter: React.FC<PoweredByFooterProps> = ({ className = '' }) => {
  return (
    <div
      className={`powered-footer text-center text-xs font-normal ${className}`}
    >
      <span className="text-black">Powered by </span>
      <span style={{ color: '#2d5d7d' }}>Health 360</span>
    </div>
  );
};

export default PoweredByFooter; 